import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";

import {BlinkButton} from "../../../../ui/Button.jsx";
import {Messages} from "../../../../Messages";
import {LinkButton} from "../../../../../core/ui/LinkButton.jsx";
import {UserPreferencesStore} from "../../../../State";
import {WidgetRoutes} from "../../../WidgetRoutes";
import {SubscriptionOverview} from "./SubscriptionOverview";
import {ArticleDetails} from "./ArticleDetails";
import {apiReactivateSubscription} from "../../../../../client/state/SubscriptionStore";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {startSubscriptionFlow} from "../../../../panel/flows/FlowEntrypoint.js";
import {LoadingSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";


// TODO Maybe merge with IndexExpandedStyle???
export class SubscriptionIndexStyle extends StyleSheet {
    @styleRule
    title = {
        fontWeight: "lighter",
        fontSize: 20,
        textAlign: "center",
    };

    @styleRule
    button = {
        marginTop: 18,
        width: "100%",
    };

    @styleRule
    supportMerchantMessage = {
        fontSize: 16,
        lineHeight: 24,
        textAlign: "center",
        marginTop: 18,
    };
}


@registerStyle(SubscriptionIndexStyle)
@autoredraw(iFrameUserDataService, UserPreferencesStore)
export class SubscriptionIndex extends UI.Element {
    async reactivateSubscription() {
        await LoadingSpinner.wrap(() => {
            apiReactivateSubscription(iFrameUserDataService.getActiveSubscription().id);
        });
    }

    render() {
        return [
            this.renderSubscriptionSection(),
            this.renderPrimaryButton(),
            this.renderSecondaryButton(),
        ];
    }

    renderSubscriptionSection() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        return subscription ? <SubscriptionOverview subscription={subscription}/> : [
            <ArticleDetails/>,
            <div className={this.styleSheet.supportMerchantMessage}>{Messages.considerSubscribing}</div>
        ];
    }

    renderSecondaryButton() {
        return iFrameMerchantService.getMerchant().allowPurchases &&
            <LinkButton
                href={WidgetRoutes.AUTOPAY}
                value={Messages.manageAutopay}
                centered
            />;
    }

    renderPrimaryButton() {
        const {styleSheet} = this;

        if (iFrameUserDataService.getActiveSubscription()) {
            return iFrameUserDataService.getActiveSubscription().isActiveButCanceled() ?
                <BlinkButton
                    label={Messages.reactivate}
                    onClick={() => this.reactivateSubscription()}
                    className={styleSheet.button}
                /> :
                <BlinkButton
                    label={Messages.manageSubscription}
                    onClick={() => startSubscriptionFlow(true, true)}
                    className={styleSheet.button}
                />;
        }

        return <BlinkButton
            label={Messages.subscribe}
            onClick={() => startSubscriptionFlow()}
            className={styleSheet.button}
        />;
    }
}
